// This is a little diddy that builds a QuickView Modal.
// Version 1, this definitely needs some cleanup.

function PostObject(handle) {
  const storefrontToken = '4d0a1fb7d8e261ce596ca71b9f144f60';

  // GraphQL Magick to get the product data.
  return {
    method: 'post',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': storefrontToken
    },
    body: `{
      productByHandle(handle:"${handle}") {
        id
        title
        description
        vendor
        handle
        totalInventory
        onlineStoreUrl
        variants(first: 100) {
          edges {
            node {
              price
              sku
              id
              title
             }
           }
        }
        priceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
        images(first: 5) {
         edges {
           node {
             src
           }
         }
       }
      }
    }`
  };
}
const storefrontUrl = 'https://greenworkstools.myshopify.com/api/graphql';

// Accessiblity functions for trapping focus and closing
// the modal via ESC key.
function trapFocus(element, prevFocusableElement = document.activeElement) {
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeQuickView();
    }
  });

  const focusableEls = Array.from(
    element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]):not([name="q"]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    )
  );

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  let currentFocus = null;

  function handleFocus(e) {
    e.preventDefault();
    console.log(e.target.getAttribute("name"));
    // if the focused element "lives" in your modal container then just focus it
    if (e.target.getAttribute("name") != "q"){
      if (focusableEls.includes(e.target)) {
        currentFocus = e.target;
      } else {
        // you're out of the container
        // if previously the focused element was the first element then focus the last
        // element - means you were using the shift key
        if (currentFocus === firstFocusableEl) {
          lastFocusableEl.focus();
        } else {
          // you previously were focused on the last element so just focus the first one
          firstFocusableEl.focus();
        }
        // update the current focus var
        currentFocus = document.activeElement;
      }
    }
  }

  document.addEventListener('focus', handleFocus, true);

  return {
    onClose: function() {
      document.removeEventListener('focus', handleFocus, true);
      prevFocusableElement.focus();
    }
  };
}

// Helper function because GraphQL hands over a base64 version of
// productID.
function getShopifyIdFromBase64(base64Id) {
  const decoded = atob(base64Id);
  const shopifyId = decoded.split('/').pop();
  return parseInt(shopifyId);
}

// Open quickview
function openQuickview(content) {
  document.body.classList.add('overflow-hidden-y');
  document.querySelector('.quickview__inner').innerHTML = content;
  document.querySelector('.quickview').classList.remove('hidden');

  var swiper = new Swiper('.swiper', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })
  trapFocus(document.querySelector('.quickview'));
  handleVariantChange();
};

// Close quickview
function closeQuickView() {
  document.querySelector('.quickview').classList.add('hidden');
  document.body.classList.remove('overflow-hidden-y');
  document.querySelector('.quickview__inner').innerHTML = '';
  trapFocus(document.querySelector('.quickview')).onClose();
}

// This runs every time the variants changes.
function handleVariantChange() {
  if (document.querySelector('[data-variant-selector]')) {
    let variantSelector = document.querySelector('[data-variant-selector]');
    variantSelector.addEventListener('change', function (event) {
      let id = event.target.value;
      let option = document.querySelector(`option[value="${id}"]`);
      let price = option.getAttribute('data-price');
      let sku = option.getAttribute('data-sku');
      // let text = option.innerText;

      document.querySelector('[data-variant-sku]').innerText = sku;
      document.querySelector('[data-variant-price]').innerText = price;
      document.querySelector('[data-variant-id]').value = id;
    });
  }
}

// Some variables for theming.
function makeQuickview(product,inventory) {
  console.log(product);
  let handle = product.handle;
  let productId = product.id;
  let variants = product.variants;
  let images = product.images;
  console.log(inventory);
  let stock = 'In Stock';
  if (inventory.trim() === 'false'.trim()) {
    stock = 'Out of Stock';
  }
  console.log(stock);
  let selectWrapped = '';
  let variantContent = '';

  if (variants.length > 1) {
    variants.forEach(function(variant, index){
      let selected = '';
      let variantObj = variant;
      let id = getShopifyIdFromBase64(variantObj.id);

      if (index == 0) {
        selected = 'selected';
      }

      selectWrapped += `<option value="${id}" data-price="${variantObj.price}" data-sku="${variantObj.sku}" ${selected}>
      ${variantObj.title}</option>`;
    });

    variantContent = `<div class="quickview__variants__heading">Options:</div>
    <div class="select" data-variant-selector><select class="select__select">${selectWrapped}</select></div>`;
  }

  let imagesWrapped = '';
  images.forEach(function(image) {
    imagesWrapped += `<div class="swiper-slide"><img src="${image.src}" alt="A" /></div>`;
  });
  //let pr = ''+variants[0].node.price;
  let pr = ''+variants[0].price;
  console.log(pr);
  let price_affirm = pr.split('.').join("");
  console.log(price_affirm);
  var content = `<div class="quickview__columns">
    <div class="quickview__images">
      <div class="swiper">
        <div class="swiper-wrapper">${imagesWrapped}</div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <div class="quickview__description">
      <div class="quickview__top">
        <div class="quickview__title">${product.title}</div>
        <div class="quickview__sku">
          SKU <span data-variant-sku>${variants[0].sku}</span>
        </div>
        <div data-bv-show="rating_summary" data-bv-productId="${productId}" data-bv-seo="false">
        </div>
        <div class="quickview__singular">
          <div class="quickview__price">$<span data-variant-price>${variants[0].price}</span></div>
          <div class="quickview__stock">${stock}</div>
        </div>
        <div class="Product Description">
          ${product.body_html}
        </div>
        `;
    if (price_affirm > 25000) {
        content += `<p class="affirm-as-low-as" data-page-type="product" data-amount="${price_affirm}"></p>`;
        //console.log("worked");
      }
      content += `</div><div class="quickview__buttons">
        ${variantContent}
        `;
  if (inventory.trim() != 'false'.trim()) {
      content += `
        <product-form>
          <form
            method="post"
            action="/cart/add"
            id="product-form-template--${productId}__main"
            accept-charset="UTF-8"
            class="form"
            enctype="multipart/form-data"
            novalidate="novalidate"
            data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" data-variant-id value="${variants[0].id}">
            <button
              id="${productId}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width"
              aria-haspopup="dialog"
              aria-labelledby="${productId}-submit"
              aria-live="polite"
              data-sold-out-message="true"
              data-close-quickview
            >
            Add To Cart
              <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </form>
        </product-form>
        `;
      }
    else{
          content += `  <button class="sold-out button button--full-width button--secondary">Coming Soon</button>`;
        }
    content += `
        <a href="/products/${handle}" class="button button--secondary button--full-width">Go To Product</a>
      </div>
    </div>
  </div>
  <div class="quickview__bazaarvoice">
    <div data-bv-show="reviews" data-bv-product-Id="${productId}" data-bv-seo="false"></div>
    <div data-bv-show="questions" data-bv-product-Id="${productId}" data-bv-seo="false"></div>
  </div>
`;
  _affirm_config = {
     public_api_key:  "7MLJV2SU8MSGEQNG",
     script:          "https://cdn1-sandbox.affirm.com/js/v2/affirm.js"
  };
  (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
  // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
    openQuickview(content);
  }


// Get the product data from GraphQL
function generateQuickview(productHandle,inventory) {
  
  // console.log(PostObject(productHandle));
  // fetch(storefrontUrl, PostObject(productHandle))
  //   .then((res) => res.json())
  //   .then((res) => {
  //     let product = res.data.productByHandle;
  //     console.log(product);
  //     if (product !== undefined) {
  //       makeQuickview(product);
  //     }
  //   });

  var store_url = "https://www.greenworkstools.com/"; // replaced with your shopify store url
      var product_id = productHandle; // replaced with your product id
      var full_url = store_url + '/products/' + product_id + '.json';
      
      $.ajax({ 
        url: full_url,
        success: function(data) {
          console.log(data);
          console.log("product id:" + data.product.id);
          console.log("product title:" + data.product.title);
          makeQuickview(data.product,inventory);
        }
      });
}

// Simple Event Listeners for opening Quickview
document.addEventListener('click',function(e){
  if(e.target.hasAttribute("data-quickview-close")) {
    closeQuickView();
  }

  if(e.target.hasAttribute("data-quickview-open")) {
    generateQuickview(e.target.getAttribute('data-quickview-open'),e.target.getAttribute("data-inventory"));
  }
});